import AssessmentFormsIndex from './AssessmentFormsIndex';
import AssessmentFormsCreate from './AssessmentFormsCreate';
import AssessmentFormsSettings from './AssessmentFormsSettings';
import AssessmentFormsSingle from './AssessmentFormsSingle';

export default function (app) {

    const settings = AssessmentFormsSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    AssessmentFormsIndex(app, settings);

    AssessmentFormsCreate(app, settings);

    AssessmentFormsSingle(app, settings);

}